import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haCaseGroupCreationPipe'
})
export class HaCaseGroupCreationPipePipe implements PipeTransform {

  transform(caseData: any[],  searchTerm: string): any[] {
    if (!caseData || !searchTerm) { return caseData; }
    return caseData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) !== -1
     




    );
  }

}
